import { Link } from 'react-router-dom'
import ArrowForwardIcon from '@mui/icons-material/ArrowForward'
import './HomeContact.css'

const HomeContact = () => {
  return (
    <section className="home-contact">
      <div className="home-contact-inner">
        <span className="eyebrow">Hafa samband</span>
        <h2>Ertu með verkefni í huga?</h2>
        <p>
          Hafðu samband og við finnum lausn sem hentar þínum þörfum.
          Þú færð svar frá okkur innan 1–2 virkra daga.
        </p>
        <div className="home-contact-actions">
          <Link to="/hafa-samband" className="btn btn-primary">
            Hafa samband <ArrowForwardIcon fontSize="small" />
          </Link>
          <a href="tel:+3544661088" className="btn btn-ghost">466-1088</a>
        </div>
      </div>
    </section>
  )
}

export default HomeContact
